import { Container } from "./styles"
import { ReactComponent as SpinnerSVG } from 'assets/spinner.svg'

const Spinner = ({ size = 20 }) => (
  <Container>
    <SpinnerSVG height={size} width={size}/>
  </Container>
)

export default Spinner
